import { trackErrorWrapperAsync } from './errorTracking';
export const NotFound = {
    status: 404,
};
export const headers = (token) => ({
    Authorization: token,
    Accept: 'application/hal+json',
    'X-Trust-SDK': JSON.stringify({
        appName: `${window.location.hostname}`,
        sdkName: 'trust-feedback',
        sdkVersion: 'not-required',
    }),
});
export const publicHeaders = () => ({
    Accept: 'application/hal+json',
    'X-Trust-SDK': JSON.stringify({
        appName: `${window.location.hostname}`,
        sdkName: 'trust-feedback',
        sdkVersion: 'not-required',
    }),
});
const parseResponseText = (data) => {
    try {
        return { data: JSON.parse(data) };
    }
    catch (e) {
        throw new Error(`error parsing json ${data}`);
    }
};
export const getPublicApi = async (relativeUrl, settings) => {
    return trackErrorWrapperAsync(async () => {
        const res = await fetch(`${settings.apiUrl}${relativeUrl}`, {
            method: 'GET',
            headers: publicHeaders(),
        });
        if (!res.ok) {
            return { error: {} };
        }
        const data = await res.text();
        return parseResponseText(data);
    });
};
export const getApi = async (relativeUrl, settings, token, options) => {
    return trackErrorWrapperAsync(async () => {
        const response = await fetch(`${settings.apiUrl}${relativeUrl}`, {
            method: 'GET',
            headers: {
                ...headers(token !== null && token !== void 0 ? token : settings.accessToken),
                "x-client-id": "nmp-trust-feedback-web-components",
            },
            ...options,
        });
        if (!response.ok) {
            if (response.status === 404 || response.status === 403) {
                return { error: { status: response.status } };
            }
            throw new Error(`Error fetching: ${settings.apiUrl}${relativeUrl} with responsetext: ${response.statusText}`);
        }
        const data = await response.text();
        if (data.length > 0) {
            return parseResponseText(data);
        }
    });
};
export const patchApi = async (newItem, relativeUrl, settings, token) => {
    return trackErrorWrapperAsync(async () => {
        const response = await fetch(`${settings.apiUrl}${relativeUrl}`, {
            method: 'PATCH',
            body: JSON.stringify(newItem),
            headers: {
                ...headers(token !== null && token !== void 0 ? token : settings.accessToken),
                'Content-Type': 'application/hal+json',
            },
        });
        if (!response.ok) {
            throw new Error(`Error patching: ${settings.apiUrl}${relativeUrl} with responsetext: ${response.statusText}`);
        }
        const data = await response.text();
        if (data.length > 0) {
            return parseResponseText(data);
        }
    });
};
export const postApi = async (newItem, relativeUrl, settings, token) => {
    return trackErrorWrapperAsync(async () => {
        const response = await fetch(`${settings.apiUrl}${relativeUrl}`, {
            method: 'POST',
            body: JSON.stringify(newItem),
            headers: {
                ...headers(token !== null && token !== void 0 ? token : settings.accessToken),
                'Content-Type': 'application/hal+json',
            },
        });
        if (!response.ok) {
            throw new Error(`Error posting: ${settings.apiUrl}${relativeUrl} with responsetext: ${response.statusText}`);
        }
        const data = await response.text();
        if (data.length > 0) {
            return parseResponseText(data);
        }
    });
};
export const createApi = async (newItem, relativUrl, settings, token) => {
    return trackErrorWrapperAsync(async () => {
        const response = await fetch(`${settings.apiUrl}${relativUrl}`, {
            method: 'POST',
            body: JSON.stringify(newItem),
            headers: {
                ...headers(token !== null && token !== void 0 ? token : settings.accessToken),
                'Content-Type': 'application/hal+json',
            },
        });
        if (!response.ok) {
            throw new Error(`Error creating item ${newItem} ${relativUrl}`);
        }
    });
};
export const deleteApi = async (relativeUrl, settings, token) => {
    await trackErrorWrapperAsync(async () => {
        const response = await fetch(`${settings.apiUrl}${relativeUrl}`, {
            method: 'Delete',
            headers: {
                ...headers(token !== null && token !== void 0 ? token : settings.accessToken),
                'Content-Type': 'application/hal+json',
            },
        });
        if (!response.ok) {
            throw new Error(`Error deleting item ${relativeUrl}`);
        }
    });
};
export const deleteApiAbsoluteURL = async (url, token) => {
    return trackErrorWrapperAsync(async () => {
        const response = await fetch(`${url}`, {
            method: 'Delete',
            headers: {
                ...headers(token),
                'Content-Type': 'application/hal+json',
            },
        });
        if (!response.ok) {
            throw new Error(`Error deleting item ${url}`);
        }
    });
};
//# sourceMappingURL=fetcher.js.map